import API from './apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/MyIMO`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetPendingReport' },
  { name: 'GetStatusReport' },
  { name: 'GetRequestsByNPN' },
  { name: 'GetRequestHistory' },
  { name: 'SubmitContractingRequest' },
  { name: 'GetChangeRequestsByNPN' },
  { name: 'GetIMORequestTypes' },
  { name: 'GetAgentRequestTypes' },
  { name: 'SubmitChangeRequest' },
  { name: 'GetAdditionalRecipients' },
  { name: 'CreateAdditionalRecipients' },
  { name: 'DeleteAdditionalRecipient' },
  { name: 'UpdateAdditionalRecipient' },
  { name: 'GetRecipientCategories' },
  { name: 'GetAllRecipientCategoriesForDropdown' },
  { name: 'SetRecipientCategories' },
]);

const GetPendingReport = (producerID) => api.endpoints.GetPendingReport.getWithURI(producerID);
const GetStatusReport = (queries) => api.endpoints.GetStatusReport.getMultipleQueryString(queries);
const GetRequestsByNPN = () => api.endpoints.GetRequestsByNPN.get();
const GetRequestHistory = (requestID) => api.endpoints.GetRequestHistory.getWithURI(requestID);
const SubmitContractingRequest = (data) => api.endpoints.SubmitContractingRequest.postData(data);
const GetChangeRequestsByNPN = () => api.endpoints.GetChangeRequestsByNPN.get();
const GetIMORequestTypes = () => api.endpoints.GetIMORequestTypes.get();
const GetAgentRequestTypes = () => api.endpoints.GetAgentRequestTypes.get();
const SubmitChangeRequest = (data) => api.endpoints.SubmitChangeRequest.postData(data);
const GetAdditionalRecipients = (lookupID) =>
  api.endpoints.GetAdditionalRecipients.getWithURI(lookupID);
const CreateAdditionalRecipients = (body) => api.endpoints.CreateAdditionalRecipients.post(body);
const DeleteAdditionalRecipient = ({ ID }) =>
  api.endpoints.DeleteAdditionalRecipient.deleteWithURI({ ID });
const UpdateAdditionalRecipient = (body) => api.endpoints.UpdateAdditionalRecipient.patch(body);
const GetRecipientCategories = (recipientId) =>
  api.endpoints.GetRecipientCategories.getWithURI(recipientId);
const GetAllRecipientCategoriesForDropdown = () =>
  api.endpoints.GetAllRecipientCategoriesForDropdown.get();
const SetRecipientCategories = (id, body) =>
  api.endpoints.SetRecipientCategories.putWithURI(id, body);

export {
  GetPendingReport,
  GetStatusReport,
  GetRequestsByNPN,
  GetRequestHistory,
  SubmitContractingRequest,
  GetChangeRequestsByNPN,
  GetIMORequestTypes,
  GetAgentRequestTypes,
  SubmitChangeRequest,
  GetAdditionalRecipients,
  CreateAdditionalRecipients,
  DeleteAdditionalRecipient,
  UpdateAdditionalRecipient,
  GetRecipientCategories,
  GetAllRecipientCategoriesForDropdown,
  SetRecipientCategories,
};
